import EChartsReact from 'echarts-for-react'
import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import { ArrowDown, ArrowUp, People } from 'react-bootstrap-icons'
import { formatNumber } from '../../../../../utils/Helper'

export default observer(function Followers({ currentAuthentication }) {

  const histories = useMemo(() => currentAuthentication.authentication_histories, [currentAuthentication.authentication_histories, currentAuthentication.authentication_histories.length])

  const option = useMemo(() => ({
  xAxis: {
    data: histories.map(history => history.history_changed_at)
  },
  yAxis: {},
  series: [
    {
      data: histories.map(history => history.follower_count),
      type: 'line',
      smooth: true,
      color: '#2CCDB4',
      areaStyle: {
        color: '#2CCDB4',
        opacity: 0.25
      }
    }
  ],
  tooltip: {
    trigger: 'item',
    formatter: '{c}'
  },
  }), [histories, histories.length])

  const growth = useMemo(() => {
    if(histories.length < 2) return 0
    const currentFollowerCount = histories[histories.length - 1].follower_count
    const previousFollowerCount = histories[histories.length - 2].follower_count
    return (currentFollowerCount - previousFollowerCount)
  }, [histories, histories.length])

  const growthPercentage = useMemo(() => {
    if(histories.length < 2) return 0
    const currentFollowerCount = histories[histories.length - 1].follower_count
    const previousFollowerCount = histories[histories.length - 2].follower_count
    if(currentFollowerCount === 0 && previousFollowerCount === 0) return 0
    if(previousFollowerCount === 0) return 'Infinity'
    return ((currentFollowerCount - previousFollowerCount) / previousFollowerCount * 100).toFixed(2)
  }, [histories, histories.length])

  const followerMin = useMemo(() => {
    if(!histories.length) return 0
    return Math.min(...histories.map(history => history.follower_count))
  }, [histories, histories.length])

  const followerMax = useMemo(() => {
    if(!histories.length) return 0
    return Math.max(...histories.map(history => history.follower_count))
  }, [histories, histories.length])

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode p-4 rounded-lg col-span-2">
      <div className="flex justify-between">
        <div className="flex items-center">
          <div className="mr-2 dark:text-white"><People /></div>
          <p className="font-bold text-xl dark:text-white">Followers</p>
        </div>
        <p className="font-bold dark:text-white">{formatNumber(currentAuthentication.reach)}</p>
      </div>
      <EChartsReact option={option} style={{ width: '100%', height: '400px' }} />
      <div className="flex justify-between">
        <div className="flex items-center">
          <p className="font-bold text-gray-300 dark:text-gray-400 mr-2">Growth</p>
          <p className="font-bold mr-4 dark:text-white">{formatNumber(growth)}</p>
          <div>
            {growth >= 0 &&
              <div className="text-green-500"><ArrowUp /></div>
              || <div className="text-red-500"><ArrowDown /></div>
            }
          </div>
          <p className={`font-bold ${growth >= 0 ? 'text-green-500' : 'text-red-500'}`}>{growthPercentage}%</p>
        </div>
        <div className="flex items-center">
          <p className="font-bold text-gray-300 dark:text-gray-400 mr-2">Min</p>
          <p className="font-bold mr-4 dark:text-white">{formatNumber(followerMin)}</p>

        </div>
        <div className="flex items-center">
          <p className="font-bold text-gray-300 dark:text-gray-400 mr-2">Max</p>
          <p className="font-bold mr-4 dark:text-white">{formatNumber(followerMax)}</p>

        </div>
      </div>
    </div>
  )
})